import React from "react";
import { Button, Modal, Toast, Badge, Picker, List } from "antd-mobile";
import { get } from "../../utils/request";
import { href } from "../../utils/util";

import { wxfx } from "../../utils/wxfx.js";
import cityData from "../data/cityData.js";
import { carData } from "../data/carData.js";
import arrayTreeFilter from "array-tree-filter";
import "./index.less";
// import mc2 from '../image/2.png';
import jieshao from "./images/js.png";
// import appQr from './images/app-QRcode.png';

// import introduce1 from './images/introduce1.png';
// import jichufuwu from './images/jichufuwu.png';
// import zengzhifuwu from './images/zengzhifuwu.png';
import chanpinfuwu from "./images/chanpinfuwu.png";
import fuwuchengnuo from "./images/fuwuchengnuo.png";
import huilianyoushi from "./images/huilianyoushi.png";
import hezuohuoban from "./images/hezuohuoban.png";
import detailbanner from "./images/detail-banner.png";
import detailbanner2 from "./images/detail-banner2.png";
import wuyouzu from "./images/wuyouzu.png";
import shiyongzu from "./images/shiyongzu.png";
import beiyongzu from "./images/beiyongzu.png";

function closest(el, selector) {
    const matchesSelector =
        el.matches ||
        el.webkitMatchesSelector ||
        el.mozMatchesSelector ||
        el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

// param = []
function urlAddParam(url, param) {
    let key = "?";
    if (url.indexOf("?") > -1) {
        key = "&";
    }
    if (param) {
        return url + key + param.join("&");
    } else {
        return url;
    }
}

class MarketingOnlineDetail extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            id: "",
            carData: "",
            modal1: false,
            modal2: false,
            city: "",
            // ZJ: '',
            // CKBJ: '',
            mobile: "",
            source: "",
            pickerValue: [],
            urlOps: {},
        };
        // this.fx();
    }
    componentDidMount() {
        // console.log(window);
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] = obj1[i].split("=")[1];
            }
            this.setState(
                {
                    id: ops.id,
                    carData: carData[ops.id],
                    city: decodeURI(ops.city),
                    // ZJ: ops.ZJ,
                    // CKBJ: ops.CKBJ,
                    mobile: ops.mobile ? ops.mobile : "",
                    source: ops.source,
                    urlOps: ops,
                },
                () => {
                    console.log(this.state.carData);
                    this.fx(ops);
                }
            );
        }
    }
    fx(ops) {
        var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        // var url = `${window.location.origin}/#/MarketingOnlineDetail?id=${ops.id}&city=${encodeURI(ops.city)}&ZJ=${ops.ZJ}`
        var url = `${
            window.location.origin
        }/payment/#/MarketingOnlineDetail?id=${ops.id}&city=${encodeURI(
            ops.city
        )}`;
        if (ops.source) {
            url = url + "&source=" + ops.source;
        }
        if (ua.indexOf("micromessenger") > -1) {
            //在微信中打开
            wxfx({
                title: "慧联在线租车，在线美好生活!",
                imgUrl: "https://image.tf56.com/dfs/group1/M00/7C/2E/CiFCK2DIPFiAd_X9AC_9mR5moC0165.png",
                desc: "送货市区进不去？试试新能源吧！",
                url: url,
            });
        }
    }
    onWrapTouchStart(e) {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, ".am-modal-content");
        if (!pNode) {
            e.preventDefault();
        }
    }

    getSel() {
        const value = this.state.pickerValue;
        if (!value) {
            return "";
        }
        const treeChildren = arrayTreeFilter(
            cityData,
            (c, level) => c.value === value[level]
        );
        return treeChildren.map((v) => v.label).join(",");
    }

    render() {
        if (!this.state.carData.id) {
            return <div></div>;
        }
        return (
            <div className="MarketingOnlineDetailBox">
                <div className="carDetail">
                    <div style={{ position: "relative" }}>
                        <img src={this.state.carData.img} />
                        {/* {this.state.carData.id == 3 ||  this.state.carData.id == 4 || this.state.carData.id == 5 || this.state.carData.id == 12|| this.state.carData.id == 13 || this.state.carData.id == 15 || this.state.carData.id == 16 || this.state.carData.id == 28   ? (<img className="marginup16" src={detailbanner} />):(<div/>)}
                        {this.state.carData.id == 18 ||  this.state.carData.id == 27  ? (<img className="marginup16" src={detailbanner} />):(<div/>)}
                        {this.state.carData.id == 20 ||  this.state.carData.id == 26  ? (<img className="marginup16" src={detailbanner2} />):(<div/>)} */}
                        {/* 活动蒙层 */}
                        {/* <div style={{ width: '100%', height: '100%', position: 'absolute', top:0, left:0, background: 'url('+mc2+') no-repeat 0 0', backgroundSize: 'cover' }}></div> */}
                    </div>

                    {/* <div>
                        <p>
                            服务包含：
                            <br/>
                            1、保险服务：交强险、商业险；
                            <br/>
                            2、运维服务：车辆保养+车辆年检、年审+救援服务+替换车服务；
                            <br/>
                            3、培训服务：提车前车辆安全培训，并根据客户需求，不定期提供培训服务。培训内容包含车辆安全驾驶、新能源车辆使用、充电桩使用培训等。
                        </p>
                    </div> */}
                </div>
                <div className="carDetailData box">
                    <div className="carName">
                        {this.state.carData.name}
                        {this.state.carData.ZCRS.length ? (
                            <span
                                style={{
                                    float: "right",
                                    color: "#999999",
                                    fontSize: "12px",
                                    fontWeight: "normal",
                                }}
                            >
                                准乘人数: {this.state.carData.ZCRS.join("人/")}
                                人
                            </span>
                        ) : (
                            ""
                        )}
                        <div style={{ marginTop: "6px" }}>
                            <Badge
                                text={this.state.carData.type}
                                style={{
                                    padding: "0 3px",
                                    backgroundColor: "#fff",
                                    color: "#10C2B0",
                                    border: "1px solid #10C2B0",
                                    borderRadius: 2,
                                    fontWeight: 500,
                                }}
                            />
                            {/* <Badge text={'全新车'} style={{ marginLeft: '8px', padding: '0 3px', backgroundColor: '#fff', color: '#F5A623',border: '1px solid #F5A623', borderRadius: 2, fontWeight: 500 }} /> */}
                        </div>
                    </div>
                    <div className="carData">
                        <div>
                            <div>
                                <span>工况续航(km)</span>
                                <div>{this.state.carData.GKXH.join("/")}</div>
                            </div>
                            {/* <div>
                                <span>准乘人数(人)</span>
                                <div>{this.state.carData.ZCRS}</div>
                            </div> */}
                            <div>
                                <span>最大载方(m³)</span>
                                <div>
                                    {this.state.carData.ZDZF.length > 0
                                        ? this.state.carData.ZDZF.join("/")
                                        : "-"}
                                </div>
                            </div>
                            <div>
                                <span>整车尺寸(m)</span>
                                <div>
                                    {this.state.carData.ZCCC.map(
                                        (item, index) => {
                                            return (
                                                <p key={"ZCCC" + index}>
                                                    {item}
                                                </p>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                            <div>
                                <span>货厢尺寸(m)</span>
                                <div>
                                    {this.state.carData.HXCC.map(
                                        (item, index) => {
                                            return (
                                                <p key={"HXCC" + index}>
                                                    {item}
                                                </p>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                            <div>
                                <span>电芯厂家</span>
                                <div>{this.state.carData.DDCJ.join("/")}</div>
                            </div>
                            <div>
                                <span>电池电量(度)</span>
                                <div>{this.state.carData.DL.join("/")}</div>
                            </div>
                        </div>
                    </div>
                    <div className="carJG">
                        {/* <div className="ZJ">
                            {this.state.ZJ}元/月
                            <Badge text={this.state.carData.newPattern ? '全新车' : '指导价'} style={{ marginLeft: 6, marginTop: '-3px', padding: '2px 6px', backgroundColor: this.state.carData.newPattern ? '#F5A623' : '#FE3824', borderRadius: 3, fontWeight: 500, fontSize: '12px', height: '20px' }} />
                        </div> */}
                        {/* <div className="del">指导价:<del>{this.state.CKBJ}元/月</del></div> */}
                    </div>
                </div>
                <div className="content margintop15">
                    <ul>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                车辆介绍
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={this.state.carData.detailImg} />
                            </div>
                        </li>

                        {/* <li className="box">
                            <div className="contentText">
                                <img src={introduce1} />
                            </div>
                        </li> */}

                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                无忧租
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={wuyouzu} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                试用租(租前试用)
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={shiyongzu} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                备用租(有偿备用)
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={beiyongzu} />
                            </div>
                        </li>
                        {/* <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                基础服务
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={jichufuwu} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                增值服务
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={zengzhifuwu} />
                            </div>
                        </li> */}
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                产品服务
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={chanpinfuwu} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                “13431”服务承诺
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={fuwuchengnuo} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                慧联实力
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={huilianyoushi} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                公司简介
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={jieshao} />
                            </div>
                        </li>
                        <li className="box">
                            <div className="contentTitle">
                                <i className="before"></i>
                                合作伙伴
                                <i className="after"></i>
                            </div>
                            <div className="contentText">
                                <img src={hezuohuoban} />
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="dianzi"></div>
                <div className="telBox">
                    <Button
                        type="ghost"
                        inline
                        style={{ marginRight: "2%", width: "49%" }}
                        onClick={() => {
                            window.Countly.q.push([
                                "add_event",
                                {
                                    key: "CarRental_CarDetails_Tel_Ck",
                                    segmentation: {},
                                },
                            ]);
                            React.$hlInsight.track(
                                "CarRental_CarDetails_Tel_Ck",
                                {}
                            );
                            this.setState(
                                {
                                    // modal2: true,
                                    modal1: true,
                                    tapType: "call",
                                },
                                () => {
                                    if (this.state.mobile) {
                                        var dom =
                                            document.getElementById(
                                                "phoneNumber"
                                            );
                                        dom.value = this.state.mobile;
                                        dom.disabled = true;
                                    }
                                }
                            );
                        }}
                    >
                        电话咨询
                    </Button>
                    <Modal
                        visible={this.state.modal1}
                        transparent
                        maskClosable={false}
                        onClose={() => {
                            this.setState({
                                modal1: false,
                            });
                        }}
                        title=""
                        footer={[
                            {
                                text: "取消",
                                onPress: () => {
                                    window.Countly.q.push([
                                        "add_event",
                                        {
                                            key: "CarRental_CarDetails_SubscribeCancel_Ck",
                                            segmentation: {},
                                        },
                                    ]);

                                    React.$hlInsight.track(
                                        "CarRental_CarDetails_SubscribeCancel_Ck",
                                        {}
                                    );
                                    this.setState({
                                        modal1: false,
                                    });
                                },
                            },
                            {
                                text: "呼叫",
                                onPress: () => {
                                    window.Countly.q.push([
                                        "add_event",
                                        {
                                            key: "CarRental_CarDetails_SubscribeSubmit_Ck",
                                            segmentation: {},
                                        },
                                    ]);
                                    React.$hlInsight.track(
                                        "CarRental_CarDetails_SubscribeSubmit_Ck",
                                        {}
                                    );
                                    window.location.href = "tel:4008262266";
                                },
                            },
                        ]}
                        wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    >
                        <div style={{ color: "#1DA57A", fontSize: "20px" }}>
                            400-826-2266
                        </div>
                    </Modal>

                    <Button
                        type="primary"
                        inline
                        className="am-button-borderfix"
                        style={{ width: "49%" }}
                        onClick={() => {
                            window.Countly.q.push([
                                "add_event",
                                {
                                    key: "CarRental_CarDetails_Subscribe_Ck",
                                    segmentation: {},
                                },
                            ]);
                            React.$hlInsight.track(
                                "CarRental_CarDetails_Subscribe_Ck",
                                {}
                            );
                            this.setState(
                                {
                                    modal2: true,
                                },
                                () => {
                                    if (this.state.mobile) {
                                        var dom =
                                            document.getElementById(
                                                "phoneNumber"
                                            );
                                        dom.value = this.state.mobile;
                                        dom.disabled = true;
                                    }
                                }
                            );
                        }}
                    >
                        我要预约
                    </Button>
                    <Modal
                        visible={this.state.modal2}
                        transparent
                        maskClosable={false}
                        onClose={() => {
                            this.setState({
                                modal2: false,
                            });
                        }}
                        title=""
                        footer={[
                            {
                                text: "取消",
                                onPress: () => {
                                    this.setState({
                                        modal2: false,
                                    });
                                },
                            },
                            {
                                text: "确定",
                                onPress: () => {
                                    const url =
                                        "/gateway/huilianCust/hlThreadcs/addHlThreadCallBack";
                                    // console.log(document.getElementById('userName').value)
                                    var userName =
                                        document.getElementById(
                                            "userName"
                                        ).value;
                                    var phoneNumber =
                                        document.getElementById(
                                            "phoneNumber"
                                        ).value;
                                    if (!userName) {
                                        Toast.info("姓名不能为空!", 1);
                                        return;
                                    }
                                    if (!phoneNumber) {
                                        Toast.info("手机号不能为空!", 1);
                                        return;
                                    }
                                    if (
                                        phoneNumber[0] != 1 ||
                                        phoneNumber.length != 11
                                    ) {
                                        Toast.info("请输入正确的手机号!", 1);
                                        return;
                                    }
                                    if (this.state.pickerValue.length === 0) {
                                        Toast.info("请选择城市!", 1);
                                        return;
                                    }
                                    if (this.state.mobile) {
                                        var resourceStr = "转介绍预约";
                                        if (this.state.tapType == "call") {
                                            resourceStr = "转介绍咨询";
                                        }
                                    } else {
                                        var resourceStr = "客户预约";
                                        if (this.state.tapType == "call") {
                                            resourceStr = "客户咨询";
                                        }
                                    }
                                    get({
                                        url,
                                        method: "GET",
                                        data: {
                                            companyName: userName,
                                            carTypes: this.state.carData.type,
                                            otherNeed: this.state.carData.name,
                                            organizationName:
                                                this.state.pickerValue[1].replace(
                                                    "市",
                                                    ""
                                                ),
                                            linkManName: userName,
                                            linkMobileNumber: phoneNumber,
                                            tierType: 4,
                                            resource:
                                                this.state.source &&
                                                this.state.source === "transfar"
                                                    ? "传化渠道"
                                                    : resourceStr,
                                            province: this.state.pickerValue[0],
                                            city: this.state.pickerValue[1],
                                            // region: this.state.pickerValue[2]
                                        },
                                    }).then(
                                        (res) => {
                                            if (res.result === "success") {
                                                this.setState({
                                                    modal2: false,
                                                });
                                                Toast.info("提交成功", 1);
                                            } else {
                                                console.log(res);
                                                Toast.info(res.msg, 1);
                                            }
                                        },
                                        (res) => {
                                            console.log(res);
                                            Toast.info(res.msg, 1);
                                        }
                                    );
                                },
                            },
                        ]}
                        wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                        className="marketingOnlineclassName"
                    >
                        <div style={{ textAlign: "left" }}>
                            <label htmlFor="userName">
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: "20%",
                                        marginRight: "5%",
                                        textAlignLast: "justify",
                                        textAlign: "justify",
                                    }}
                                >
                                    姓 名
                                </span>
                                <input
                                    id="userName"
                                    type="text"
                                    maxLength="10"
                                    style={{
                                        "-webkit-appearance": "none",
                                        outline: "none",
                                        width: "70%",
                                        height: "42px",
                                        borderRadius: "5px",
                                        border: "1px solid #EBEBEB",
                                    }}
                                />
                            </label>
                            <label
                                htmlFor="phoneNumber"
                                style={{ display: "block", marginTop: "16px" }}
                            >
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: "20%",
                                        marginRight: "5%",
                                        textAlignLast: "justify",
                                        textAlign: "justify",
                                    }}
                                >
                                    手机号
                                </span>
                                <input
                                    id="phoneNumber"
                                    type="tel"
                                    maxLength="11"
                                    style={{
                                        "-webkit-appearance": "none",
                                        outline: "none",
                                        width: "70%",
                                        height: "42px",
                                        borderRadius: "5px",
                                        border: "1px solid #EBEBEB",
                                    }}
                                />
                            </label>
                            <label
                                style={{ display: "block", marginTop: "16px" }}
                            >
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: "20%",
                                        marginRight: "5%",
                                        textAlignLast: "justify",
                                        textAlign: "justify",
                                    }}
                                >
                                    用车地
                                </span>
                                <div className="citySelect">
                                    <Picker
                                        extra="选择城市"
                                        cols="2"
                                        visible={this.state.visible}
                                        data={cityData}
                                        value={this.state.pickerValue}
                                        onChange={(v) =>
                                            this.setState({ pickerValue: v })
                                        }
                                        onOk={() =>
                                            this.setState({ visible: false })
                                        }
                                        onDismiss={() =>
                                            this.setState({ visible: false })
                                        }
                                    >
                                        <List.Item
                                            extra={this.getSel()}
                                            onClick={() =>
                                                this.setState({ visible: true })
                                            }
                                        ></List.Item>
                                    </Picker>
                                </div>
                            </label>
                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#999",
                                    marginTop: "16px",
                                }}
                            >
                                *提交申请后我们将尽快与您联系
                            </div>
                        </div>
                    </Modal>
                </div>
                {this.state.urlOps.back === "hide" ? (
                    ""
                ) : (
                    <a
                        className="black"
                        onClick={() => {
                            const { urlOps, mobile } = this.state;
                            if (mobile) {
                                href(
                                    urlAddParam(
                                        `/MarketingOnlineIndex?mobile=${mobile}`,
                                        urlOps.source ? ["source=transfar"] : ""
                                    )
                                );
                            } else {
                                href(
                                    urlAddParam(
                                        `/MarketingOnlineIndex`,
                                        urlOps.source ? ["source=transfar"] : ""
                                    )
                                );
                            }
                        }}
                    >
                        返回上页
                    </a>
                )}
            </div>
        );
    }
}

export default MarketingOnlineDetail;



// WEBPACK FOOTER //
// ./src/marketingOnline/detail/index.js